import { useState } from "react";

import Button from "@components/button/button";
import { buttonTheme } from "@components/button/button-constants";

import SummaryWeekBlock from "./summary-week-block";

const ProfileSummaryTab = ({ profileId }: { profileId: number }) => {
  const [weekOffsets, setWeekOffsets] = useState([0]);

  const handleLoadPreviousWeek = () => {
    setWeekOffsets((offsets) => [...offsets, Math.max(...offsets) + 1]);
  };

  return (
    <div className="mx-auto flex w-full max-w-2xl flex-col gap-8 pt-2">
      <div className="flex flex-col gap-6">
        {weekOffsets.map((offset) => (
          <SummaryWeekBlock
            key={offset}
            userId={profileId}
            weekOffset={offset}
          />
        ))}
      </div>
      <div className="flex justify-center">
        <Button
          theme={buttonTheme.default}
          onClick={handleLoadPreviousWeek}
          text="Load previous week"
          aria-label="Load previous week"
        />
      </div>
    </div>
  );
};

export default ProfileSummaryTab;
